import * as Yup from 'yup'

export const WebHookSchema = Yup.object().shape({
  apiWebhook: Yup.string().trim().required('URL do WebHook obrigatório.'),
})
